import { BCKSInvitationReview } from 'app/BCKSPage/Invitation/review'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsInvitationDocumentReviewPage {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const BCKSInvitationDocumentReview = (
  props: PropsInvitationDocumentReviewPage
) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <BCKSInvitationReview />
}

// eslint-disable-next-line react/display-name
BCKSInvitationDocumentReview.Layout = ({ children }) => children

export default BCKSInvitationDocumentReview
